import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SubstationTemplateService, UtilitySharedService, PermissionsService } from 'shared-lib';

@Component({
  selector: 'app-asset-list-sidenav',
  templateUrl: './asset-list-sidenav.component.html',
  styleUrl: './asset-list-sidenav.component.scss',
  standalone: false,
  animations: [
    trigger('equipmentSubmenuAnimation', [
      state('closed', style({
        height: '0px',
        opacity: 0
      })),
      state('open', style({
        height: '*',
        opacity: 1
      })),
      transition('closed <=> open', [
        animate('250ms ease-in-out')
      ])
    ])
  ]
})
export class AssetListSidenavComponent implements OnInit {
  collapsed: boolean = false;
  items: any = [];
  utilityId: number = 0;

  equipmentSubmenuOpen = false;
  equipmentSubmenuItems = [
    { id: 1, name: 'Power Transformer', icon: "Transformer-2" },
    { id: 2, name: 'AC Line Segment', icon: "Ac Line Segment" },
    { id: 3, name: 'Switch Gear', icon: "Switch" },
    { id: 4, name: 'Conductor', icon: "NodeEnergy-2" },
    { id: 5, name: 'Busbar', icon: "Busbar" },
    { id: 6, name: 'Junction', icon: "Junction-1" },
    { id: 7, name: 'Jumper', icon: "Jumper" },
    { id: 8, name: 'Fuse', icon: "Fuse" },
    { id: 9, name: 'Disconnector', icon: "Disconnector" },
    { id: 10, name: 'Ground Disconnector', icon: "Ground Disconnector" },
    { id: 11, name: 'Load Break Switch', icon: "Load-Break-Switch" },
    { id: 12, name: 'Breaker', icon: "Circuit-Breaker" },
    { id: 13, name: 'Ground', icon: "Placeholder" },
    { id: 14, name: 'Recloser', icon: "Placeholder" },
    { id: 15, name: 'Cut', icon: "Placeholder" },
    { id: 16, name: 'Sectionaliser', icon: "Placeholder" },
    { id: 17, name: 'Petersen Coil', icon: "Placeholder" },
    { id: 18, name: 'Shunt Compensator', icon: "Placeholder" },
    { id: 19, name: 'Frequency Converter', icon: "Placeholder" },
    { id: 20, name: 'Static Var Compensator', icon: "Placeholder" }
  ];

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private substationTemplateService: SubstationTemplateService,
    private utilitySharedService: UtilitySharedService,
    public permissionsService: PermissionsService
  ) {
    this.utilityId = this.utilitySharedService.getUtilityId() ?? 0;
    this.getSidebarSubstations();
  }

  ngOnInit(): void {
    if (!this.collapsed && this.isEquipmentRoute()) this.equipmentSubmenuOpen = true;
  }

  getSidebarSubstations(){
    this.substationTemplateService.getAllForSidebar(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        this.items = responseData ? responseData.data : [];
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading substation templates');
      },
    });
  }

  toggleSidebar() {
    this.collapsed = !this.collapsed;
    if(this.collapsed) this.equipmentSubmenuOpen = false;
    if (!this.collapsed && this.isEquipmentRoute()) this.equipmentSubmenuOpen = true;
  }

  navigateCim(id: number){
    this.router.navigate(['/asset-list/cim-substations/', id]);
    
  }

  navigate(route: string){
    if(route === ''){
      this.toastr.info('Not Implemented Yet');
      return;
    }
    this.router.navigate(['/asset-list/', route]);
  }

  toggleSubmenu() {
    if (this.collapsed) {
      this.collapsed = false;
      this.equipmentSubmenuOpen = true;
      return;
    }
    this.equipmentSubmenuOpen = !this.equipmentSubmenuOpen;
  }

  private isEquipmentRoute(): boolean {
    return this.router.url.includes('cim-equipment');
  }
}
